module.exports = __webpack_public_path__ + "images/emoji/bamboo.7dbf4de405a86a345c73.png";